import React, { Component } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import { gofor } from '@fiverr-private/futile/lib/gofor';
import './index.scss';

let ticking = false;

export default class StickyProfile extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOnline: false,
            lastScrollY: window.scrollY
        };

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);

        gofor(`/users/${this.props.sellerCard.user.username}/is_online`, {
            method: 'GET'
        }).then((response) => response.json())
            .then((response) => {
                if (response) {
                    this.setState({
                        isOnline: response.is_online === true
                    });
                }
            })
            .catch((err) => {
                throw err;
            });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll() {
        if (!ticking && window.innerWidth < 959) {
            window.requestAnimationFrame(() => {
                this.setState({ lastScrollY: window.scrollY });
                ticking = false;
            });

            ticking = true;
        }
    }

    render() {
        const { sellerCard, contactClick, scrollPosition } = this.props;
        const { isOnline, lastScrollY } = this.state;

        const { user } = sellerCard;
        const showContact = user.has_live_gigs && (!user.is_on_vacation || (user.is_on_vacation && user.allow_contact));
        const contactLink = user.contact_path || `/conversations/${user.username}`;
        const userRatingsCount = parseInt(user.ratings_count, 10);
        const stickyProfileClass = classnames(['sticky-user-profile', {'open': lastScrollY > scrollPosition, 'is-online': isOnline}]);

        return (
            <div className={stickyProfileClass}>
                <div className="user-profile">
                    <img src={user.profile_photo}/>

                    <div className="user">
                        <span>{user.username}</span>
                        <div className="ratings-wrapper">
                            <span className="star-rating-s15" data-user-rating={user.rating} data-user-ratings-count={user.ratings_count}></span>
                            <strong>{user.rating.toFixed(1)}</strong> <I18n k="user_page_perseus.seller_profile.num_reviews" params={{ count: userRatingsCount < 1000 ? userRatingsCount : '1k+' }}/>
                        </div>
                    </div>
                </div>

                {showContact &&
                    <a href={contactLink}
                        className="btn-standard btn-contact btn-white"
                        onClick={contactClick}
                        ref={(ele) => { this.contactBtn = ele; }}
                        rel="nofollow"
                        data-user-id={user.username}
                        data-redirect-url={contactLink}>
                        <I18n k="user_page_perseus.seller_profile.contact"/>
                    </a>}
            </div>
        );
    }
}

StickyProfile.propTypes = {
    sellerCard: PropTypes.shape({
        user: PropTypes.object.isRequired
    }),
    contactClick: PropTypes.func,
    scrollPosition: PropTypes.number
};

StickyProfile.defaultProps = {
    contactClick: () => null,
    scrollPosition: 350
};
